// React
import { forwardRef } from 'react';
import cn from 'classnames';
// Types
import Slider, { Settings } from 'react-slick';
// Ui
import Carousel from 'ui3/Carousel/Carousel';
// Styles
import styles from './CarouselSlider.module.scss';

const sliderSettings = {
  infinite: false,
  adaptiveHeight: false,
  speed: 500,
  swipeToSlide: true,
  variableWidth: true,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
} as Settings;

type CarouselSliderProps = {
  settings?: Settings;
  children: React.ReactNode;
  className?: string;
};

const CarouselSlider = forwardRef<Slider, CarouselSliderProps>(
  ({ children, settings, className }, ref) => {
    return (
      <div className={cn(styles.root, className)}>
        <Carousel
          ref={ref}
          {...sliderSettings}
          {...settings}
          className={styles.slider}
        >
          {children}
        </Carousel>
      </div>
    );
  }
);

CarouselSlider.displayName = 'CarouselSlider';

export default CarouselSlider;
